
import BaseImage from '@/common/components/BaseImage.vue'
import { IMAGE_VARIANT } from '@/common/const'
import Vue from 'vue'

export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    skuImages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      mainImage: this.skuImages[0].thumbnail ?? '',
      caption: this.skuImages[0].caption ?? ''
    }
  },
  computed: {
    THUMBNAIL_IMG_VARIANT() {
      return IMAGE_VARIANT.SKU_THUMBNAIL
    },
    ACTIVE_IMG_VARIANT() {
      return IMAGE_VARIANT.SKU_MAIN
    },
    formattedImageDescription() {
      let urlRegex = /(https?:\/\/[^\s]+)/g
      return this.caption.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>'
      })
    }
  },
  watch: {
    skuImages() {
      this.mainImage = this.skuImages[0].thumbnail ?? ''
      this.caption = this.skuImages[0].caption ?? ''
    }
  },
  methods: {
    onHover(skuImage: any) {
      this.mainImage = skuImage.thumbnail
      this.caption = skuImage.caption ?? ''
    }
  }
})
